import Constants from "../utils/constants";
import { API } from "../apis/APIsConfig";

export function getObtenerValorPorCodigo(codigo: String) {
  return API.get(Constants.APIURLS.OBTENERVALORPORCODIGO + codigo);
}
